import { RavenInputField } from "@ravenpay/raven-bank-ui";
import React, { useContext } from "react";
import { reactSelectStyle } from "../utils/helpers";
import ActionContext from "../context/ActionContext";
import "../styles/fragments/PerPageComponent.css";

interface MyComponentProps {
  className?: string;
  perPageVal?: string;
  setPerPageVal?: (param?: any) => void;
}

export const perPageList = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "250", value: 250 },
  { label: "500", value: 500 },
  { label: "1000", value: 1000 },
  { label: "2000", value: 2000 },
  { label: "3000", value: 3000 },
];

const PerPageComponent: React.FC<MyComponentProps> = ({
  className,
  perPageVal,
  setPerPageVal,
}) => {
  const actionCtx = useContext(ActionContext);
  return (
    // <div className={`per-page-wrapper-class-index ${className}`}>
    <RavenInputField
      type="select"
      color="deep-green-light"
      selectStyles={reactSelectStyle}
      value={perPageVal ? perPageVal : actionCtx?.perPageGlobalVal}
      onChange={(e: any) => {
        setPerPageVal && setPerPageVal(e);
        actionCtx.setPerPageGlobalVal(e);
      }}
      selectOption={perPageList}
      className={`per-page-wrapper-class-index card-bg ${className}`}
    />
    // </div>
  );
};

export default PerPageComponent;
